import {SearchStoreQuery} from './types';

export const CATALOG_CURRENCY_QUERY = (currencyCode: string): string => `
{
    Catalog {
        currency(currencyId: "${currencyCode}") {
            code
            symbol
            decimals
            description
        }
    }
}`;

export const CATALOG_OFFER_QUERY = (
	sandboxId: string,
	offerId: string,
	locale: string,
	country: string
) => `
{
    Catalog {
        catalogOffer(namespace: "${sandboxId}", id: "${offerId}", locale: "${locale}") {
            title
            description
            id
            locale
            namespace
            countriesBlacklist
            allowPurchaseForPartialOwned
            offerType
            isCodeRedemptionOnly
            urlSlug
            url
            keyImages {
                type
                url
            }
            categories {
                path
            }
            offerMappings {
                mappings {
                    cmsSlug
                }
                pageSlug
                pageType
            }
            price(country: "${country}") {
                totalPrice {
                    originalPrice
                    currencyCode
                    currencyInfo {
                        decimals
                    }
                    fmtPrice(locale: "${locale}") {
                        originalPrice
                        discountPrice
                        intermediatePrice
                    }
                }
            }
        }
    }
}`;

export const CATALOG_COUNTRY_QUERY = (countryCode: string) => `
{
    Catalog {
        countryData(countryCode: "${countryCode}") {
            ratingSystems
        }
    }
}
`;

export const CATALOG_OFFER_ITEMS_QUERY = (namespace: string, offerId: string, locale: string) => `
{
    Catalog {
        offerSubItems(namespace: ${namespace}, id: ${offerId}, locale: ${locale}) {
            id
            title
            ageGatings {
                ratingSystem
                ageControl
                gameRating
                ratingImage
                title
                descriptor
                element
            }
        }
    }
}
`;

export const CATALOG_SEARCH_QUERY = ({
	allowCountries,
	category,
	count,
	country,
	locale,
	namespace,
	sortBy,
	sortDir,
	withPrice = false,
	withPromotions = false
}: SearchStoreQuery) => `
{
    Catalog {
        searchStore(
            allowCountries: "${allowCountries}",
            category: "${category}",
            count: ${count},
            country: "${country}",
            locale: "${locale}",
            namespace: "${namespace}",
            sortBy: "${sortBy}",
            sortDir: "${sortDir}"
        ) {
            elements {
                title
                id
                namespace
                countriesBlacklist
                allowPurchaseForPartialOwned
                isCodeRedemptionOnly
                urlSlug
                url
                keyImages {
                    type
                    url
                }
                categories {
                    path
                }
                offerMappings {
                    mappings {
                        cmsSlug
                    }
                    pageSlug
                    pageType
                }
                price(country: "${country}") @include(if: ${withPrice}) {
                    totalPrice {
                        originalPrice
                        currencyCode
                        currencyInfo {
                            decimals
                        }
                        fmtPrice(locale: "${locale}") {
                            originalPrice
                            discountPrice
                            intermediatePrice
                        }
                    }
                }
                promotions(category: "${category}") @include(if: ${withPromotions}) {
                    promotionalOffers {
                      promotionalOffers {
                        startDate
                        endDate
                        discountSetting {
                          discountType
                          discountPercentage
                        }
                      }
                    }
                    upcomingPromotionalOffers {
                      promotionalOffers {
                        startDate
                        endDate
                        discountSetting {
                          discountType
                          discountPercentage
                        }
                      }
                    }
                }
            }
            paging {
                count,
                total
            }
        }
    }
}`;
